import { EVENTS } from '../../../../app/constants/events';
import {
  DEFAULT_SCHEMA_SETTINGS,
  getSettingsForComponent,
} from '../../../../app/package-designer/helpers/schema-importer-settings.helper';

xplenty.controller('SchemaImporterSettingsController', [
  '$scope',
  '$rootScope',
  '$stateParams',
  '$timeout',

  function ($scope, $rootScope, $stateParams, $timeout) {
    $scope.selectedFieldsOptions = { ...DEFAULT_SCHEMA_SETTINGS };

    $scope.availableFieldsOptions = {
      add: true,
      showSourceDesignatorInSelectedFields: true,
    };

    const setSettings = function (component) {
      const settings = getSettingsForComponent(component, component);

      $scope.selectedFieldsOptions = settings;
      $scope.availableFieldsOptions.sourceDesginatorName = settings.sourceDesginatorName;
      // if you can't remove a specific field, you can't add specific field (all or nothing behavior)
      $scope.availableFieldsOptions.add = settings.allowToRemoveSelectedFields;

      $scope.$on(EVENTS.SCHEMA_IMPORTER_REFRESH, function () {
        $scope.showSelectedFields = false;
        $timeout(function () {
          $scope.showSelectedFields = true;
        });
      });
    };

    $scope.$watch('component', setSettings, true);
  },
]);
